import React, { Component } from 'react';
import FileViewer from './FileViewer';
import '../Style/components.css';

export class Modal extends Component {
  render() {
    return (
      <React.Fragment>
        <FileViewer
          file={this.props.file}
          open_close_file={this.props.open_close_file}
        />
        <div
          style={
            this.props.current.show ? { display: 'block' } : { display: 'none' }
          }
          className="menu"
        >
          <div className="close" onClick={() => this.props.push_current(false)}>
            <i className="fi-rr-cross"></i>
          </div>
          <h3 className="head_text">{this.props.current.header}</h3>
          <div className="folder_body">
            {this.props.current.files.map((file, i) => (
              <div
                key={i}
                onDoubleClick={(e) => this.props.open_close_file(true, file)}
                className="root_icons"
              >
                {file.type === 'image' ? (
                  <i className="fi-rr-picture"></i>
                ) : file.type === 'video' ? (
                  <i className="fi-rr-film"></i>
                ) : file.type === 'audio' ? (
                  <i className="fi-rr-music-alt"></i>
                ) : file.type === 'text' ? (
                  <i className="fi-rr-text"></i>
                ) : file.type === 'pdf' ? (
                  <i className="fi-rr-book-alt"></i>
                ) : (
                  <i className="fi-rr-interrogation"></i>
                )}
                <p className="folder_name">{file.name}</p>
              </div>
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Modal;
